import React from 'react';

import { useLink } from '@zapier/common-hooks';

import { Interval } from '@zapier/design-system-revenue/src/types';
import { buildUpgradeUrl } from '@zapier/design-system-revenue/src/utils';

import { UpgradeButton } from '../UpgradeButton';

export const UpgradeButtonToPricingPage = ({
  currentPlanInterval,
  currentPlanName,
  nextPlanName,
  onClick,
}: {
  currentPlanInterval: Interval;
  currentPlanName: string;
  nextPlanName: string;
  onClick?: () => void;
}) => {
  const { routeTo } = useLink();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    if (routeTo) {
      routeTo(
        buildUpgradeUrl(currentPlanName, nextPlanName, currentPlanInterval)
      );
    }
  };

  return <UpgradeButton onClick={handleClick} />;
};
